import PropTypes from 'prop-types';

import {
    DATA_FORMAT_TYPES,
    SORT_DIRECTIONS
} from '../../../constants';

export const COLUMN_PROP_TYPES = PropTypes.shape({
    dataField: function(props, propName, componentName) {
        const dataFormat = props['dataFormat'];

        if (dataFormat !== DATA_FORMAT_TYPES.SELECT && !props[propName]) {
            return new Error(`Invalid prop '${propName}' supplied to '${componentName}'.`
                + ` '${propName}' should be specified for any data format except '${DATA_FORMAT_TYPES.SELECT}'.`);
        }
    },
    name: PropTypes.string,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    isSortable: PropTypes.bool,
    dataFormat: PropTypes.oneOf([...Object.values(DATA_FORMAT_TYPES)]),
    dataFormatProps: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    md: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number
});

export const COL_PROP_TYPES = PropTypes.shape({
    className: PropTypes.string,
    headerName: PropTypes.string,
    colProps: PropTypes.shape({
        md: PropTypes.number,
        lg: PropTypes.number,
        xl: PropTypes.number
    })
});

export const CELL_PROP_TYPES = PropTypes.shape({
    ...COL_PROP_TYPES,
    value: PropTypes.any,
    extraProps: PropTypes.object
});

export const SORT_DIRECTION_PROP_TYPES = PropTypes.oneOf([
    SORT_DIRECTIONS.ASC,
    SORT_DIRECTIONS.DESC
]);
